export default __webpack_public_path__ + "static/image4-681b63c56a6455ffeae33b1b2f2ae952.jpeg";